<template>
  <div>

    <v-btn @click="signInWithGoogle" class="login-button mb-4" outlined large depressed>
      <img class="logo-google" :src="firebase_host + '/static/img/google.png'">
      Login con Google</v-btn>

    <v-btn @click="signInWithApple" class="login-button" outlined large depressed>
      <v-icon class="black--text" left>fa-apple</v-icon>
      Login con Apple</v-btn>

  </div>
</template>

<script>

import mixins from '../../js/mixins'

// import { getApp } from 'firebase/app';
import { getAuth, signInWithPopup, GoogleAuthProvider, OAuthProvider, signInWithCustomToken, signInWithCredential } from 'firebase/auth';
import { auth, authShared } from '../../../config-firebase/firebase'

// let firebaseApp = getApp(); // [DEFAULT]

// const auth = getAuth(firebaseApp);

import toast from "../../js/toast";
import Config from '../../../config-app/config';
import store from '../../store'

export default {
  name: 'login-sdk-fb',
  mixins: [mixins, toast],
  data() {
    return {
      firebase_host: Config.FIREBASE_HOST,
    }
  },

  methods: {

    signInWithGoogle() {
      const provider = new GoogleAuthProvider();
      signInWithPopup(authShared, provider)
        // Vedi dettagli in LoginSdkJs -> handleSignInWithCredential
        // .then((result) => {
        //   return GoogleAuthProvider.credentialFromResult(result);
        // })
        // Vedi dettagli in LoginSdkJs -> handleSignInWithCredential
        // .then((credentials) => {
        //   return signInWithCredential (auth, credentials)
        // })
        .then((result) => {
          const user = result.user
          this.successToast('Ciao', user.displayName);
          let redirect = this.$route.query.redirect || '/';
          this.$router.push({ path: redirect });
        })
        .catch(error => {
          this.errorToast("Google Login Error", error.message);
          console.log("Google Login Error: ", error);
        });
    },
    signInWithApple() {

      // https://firebase.google.com/docs/auth/web/apple?authuser=0
      let provider = new OAuthProvider('apple.com');
      provider.addScope('email');
      provider.addScope('name');
      provider.setCustomParameters({
        locale: 'it'
      });

      signInWithPopup(authShared, provider)
        // Vedi dettagli in LoginSdkJs -> handleSignInWithCredential
        // .then((result) => {
        //   return OAuthProvider.credentialFromResult(result);
        //   // let credential = result.credential;
        //   // console.log("credential: ", credential);

        //   // You can also get the Apple OAuth Access and ID Tokens.
        //   // let accessToken = credential.accessToken;
        //   // let idToken = credential.idToken;

        //   // IdP data available using getAdditionalUserInfo(result)
        //   // ...
        // })
        // .then((credentials) => {
        //   return signInWithCredential(auth, credentials)
        // })
        .then((result) => {
          const user = result.user
          this.successToast('Ciao', user.displayName);
          let redirect = this.$route.query.redirect || '/';
          this.$router.push({ path: redirect });
        })
        .catch((error) => {
          this.errorToast("Apple Login Error", error.message);
          console.log("Apple Login Error: ", error);
        });
    },


  },

  mounted() {
    console.log('Login ready.')
  },

  created() {

  },

  destroyed() {
    console.log('Login destroyed.');
  }
}
</script>

<style lang="scss" scoped>
.logo-google {
  margin-right: 6px;
}

.login-button {
  width: 100%;
  text-transform: none !important;
  font-weight: bold;
  font-size: 16px;
  letter-spacing: inherit;
  background-color: transparent !important;
}
</style>
